import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import {
    Container,
    Typography,
    Stack,
} from '@mui/material';

import { DomainAddressDataTable, DomainAddressForm } from '../sections/@dashboard/domainMonitor';

const StyledCard = styled('div')(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]         
      : theme.palette.background.paper, 

  padding: theme.spacing(2.5),
  borderRadius: 20,

  boxShadow:
    theme.palette.mode === 'light'
      ? '0px 0px 10px rgba(0, 0, 0, 0.15)'
      : '0px 0px 10px rgba(0, 0, 0, 0.6)',
}));


const SpaceBetweenComponents = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2.5), 
}));



export default function MonitorPage() {
    const [reloadData, setReloadData] = useState(false);

    return (
        <>
            <Helmet>
                <title>API Monitor | WatchNod</title>
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <Container maxWidth="xl">
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Typography variant="h3" component="h1" gutterBottom>
                    API Monitor
                    </Typography>
                </Stack>
                <StyledCard>
                    <DomainAddressForm reloadData={() => setReloadData(!reloadData)} />
                    <SpaceBetweenComponents />
                    <DomainAddressDataTable key={reloadData} />
                </StyledCard>
            </Container>
        </>
    );
}
